import { styled } from 'styled-components';

export const ClientSideErrorContainer = styled.div`
    min-height: 30rem;
    margin-top: 2rem;
`;
